// extracted by mini-css-extract-plugin
module.exports = {"reportCardHeader":"ReportCardHeader_reportCardHeader__3C0-0","incidentNumber":"ReportCardHeader_incidentNumber__Y33kh"};